module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_7042.a3ef1e50.png";